import type { LiveServicesMapping } from './state';

function getLiveServicesTenantId(
  tenantId: number,
  toAddress: string,
  mappings: LiveServicesMapping[],
): string {
  const mapping = mappings.find((m) => m.phoneNumber === toAddress);
  // If no mapping is found, fall back to the raw numeric RTCS tenant ID. This is intentional —
  // the call will still be routed using the original Live Services tenant, per PM decision.
  return mapping ? mapping.tenantId : tenantId.toString();
}

export default getLiveServicesTenantId;
